
import { CategoryCard } from "../../components/category-card/CategoryCard";
import { ProviderCard } from "../../components/provider-card/ProviderCard";
import "./ProviderTop.css";

export function ProviderTop() {
  return (
    <div className="container">
      <h2 className="provider-title">
        Lo más buscado del mes
      </h2>


      <div className="container provider-top">
        <ProviderCard
          image="/assets/icons/medicos.svg"
        />
        <ProviderCard
          image="/assets/icons/farmacia.svg"
        />
        <ProviderCard
          image="/assets/icons/hospitales.svg"
        />
      </div>
    </div>
  );
}